export default "__VITE_ASSET__237c95ef__"